import { RESOURCES } from './content/common';
import { ITEMS, GENERATORS } from './content/items';
import { MAPS } from './content/maps';
import { LEVELS } from './content/levels';
import { STORY_BEATS } from './content/story';
import { BOTS } from './content/bots';
import { SHOP_ITEMS } from './content/shop';

export const instantiate = (original) => {
  return JSON.parse(JSON.stringify({
    ...original,
    uid: crypto.randomUUID()
  }));
};

export {
  RESOURCES,
  ITEMS,
  GENERATORS, 
  MAPS,
  STORY_BEATS,
  LEVELS,
  BOTS,
  SHOP_ITEMS
};
